const ServiceData = {
    buroojtrading: {
        crum: "Burooj Trading",
        title: "Global Products, Easy Trade",
        subtitle:
            "Connecting retailers with international brands through trade solutions.",
        description:
            "At Burooj, our Trading division is built on one mission: supporting retailers across Oman and the GCC by bringing world-class products closer to them. We bridge the gap between global brands and local markets, offering retailers easy access to premium products under flexible trade terms. With expertise in sourcing, distribution, and trade support, we ensure that businesses grow stronger with reliable and cost-effective supply solutions.",
        image: "/imges/service/buroojtrading.jpeg",
        offerings: {
            title: "Our Offerings",
            sections: [
                {
                    direction: "rhs",
                    heading: "FMCG Products – Basmati Rice, Coffee, Chocolates, Frozen Chicken & Meat",
                    content:
                        "We source and distribute high-demand FMCG products from trusted international and regional suppliers. Our product portfolio supports retailers, wholesalers, and food service businesses with dependable supply channels.",
                    keyFeatures: [
                        "Premium food and beverage products.",
                        "Consistent supply and distribution support.",
                        "Products selected for market demand.",
                    ],
                    image: "/imges/service/basmatirice.jpeg",
                },
                { showRiceCategory: true },
                {
                    direction: "lhs",
                    heading: "Building Materials – Special Products",
                    content:
                        "We supply a wide range of building materials and specialty products for residential, commercial, and industrial projects. Through trusted manufacturers and suppliers, we provide reliable materials that meet quality standards and project requirements.",
                    keyFeatures: [
                        "Quality-assured construction materials.",
                        "Access to specialized building products.",
                        "Reliable supply for projects of all sizes.",
                    ],
                    image: "/imges/service/buildingMaterials.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Electrical Materials",
                    content:
                        "Our electrical materials division provides products suitable for infrastructure, commercial, and industrial applications. We source dependable electrical components that support safe installations and long-term operational performance",
                    keyFeatures: [
                        "Comprehensive range of electrical products.",
                        "Products sourced from trusted manufacturers.",
                        "Consistent availability and supply support.",
                    ],
                    image: "/imges/service/electricalMaterial.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Construction Chemicals",
                    content:
                        "We offer construction chemicals designed to enhance durability, protection, and performance in building projects. Our solutions support contractors and developers in meeting modern construction requirements.",
                    keyFeatures: [
                        "Products for waterproofing and repair.",
                        "Solutions for concrete enhancement.",
                        "Reliable support for construction projects.",
                    ],
                    image: "/imges/service/constructionChemical.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Geogrid, Geotextile & Geomembrane",
                    content:
                        "We provide geosynthetic solutions for infrastructure, environmental, and civil engineering applications. Our product range supports soil stabilization, drainage, reinforcement, and containment requirements across diverse projects.",
                    keyFeatures: [
                        "Solutions for soil reinforcement.",
                        "Products for drainage and erosion control.",
                        "Suitable for infrastructure and environmental projects.",
                    ],
                    image: "/imges/service/geogridGeotextile.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Ironmongery & Surface Protection Materials",
                    content:
                        "Our range includes ironmongery products and surface protection materials used in commercial and industrial developments. We help clients maintain durability, safety, and long-term protection of structures and finishes.",
                    keyFeatures: [
                        "Quality architectural ironmongery products.",
                        "Surface protection for demanding environments.",
                        "Durable solutions for project requirements.",
                    ],
                    image: "/imges/service/Ironmongery.jpeg",
                },
            ],
        },

        whyChooseUs: {
            title: "Why Choose Burooj Trading?",
            points: [
                {
                    title: "Expert Global<br/> Sourcing",
                    description:
                        "We bring top international brands directly to retailers.",
                    image: "/imges/service/Global.png",
                },
                {
                    title: "Seamless<br/> Logistics",
                    description:
                        "From import to store shelves, handled with ease.",
                    image: "/imges/service/Seamless.png",
                },
                {
                    title: "Tailored Trade <br>Solutions",
                    description:
                        "Easy financing to keep retail business moving.",
                    image: "/imges/service/Trade.png",
                },
                {
                    title: "Market Expansion <br>Support",
                    description:
                        "Helping retailers and brands expand across the region.",
                    image: "/imges/service/Market.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Trading",
            content:
                "At Burooj Trading, we’re committed to empowering retailers with access to international brands, reliable supply chains, and easy trade terms. Whether you’re a retailer looking to expand your product offering or a brand aiming to enter the Omani market, our team is here to help you grow.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/open-service-2-1.png",
        },
    },
    buroojinvestments: {
        crum: "Burooj Investments",
        title: "Smart Capital, Strategic Growth",
        subtitle: "Investment Management through Private Equity",
        description: `At Burooj Investments, we don’t just invest—we create value. As a dynamic investment firm, we identify and capitalize on high-growth opportunities across multiple sectors, fueling economic progress and financial success. Our investment strategy is rooted in innovation, sustainability, and strategic foresight, ensuring that we generate long-term returns for our stakeholders while contributing to industry-wide transformation.
      Burooj Investments is committed to making capital work smarter by identifying high-potential opportunities and strategically allocating resources for long-term growth. With a focus on venture capital, private equity, and ethical wealth creation, we empower businesses and investors to unlock financial success. Our expertise spans multiple investment avenues, ensuring businesses receive the capital they need to scale while providing investors with solid returns`,
        image: "/imges/service/buroojinvestment.png",
        offerings: {
            title: "Investment Areas",
            sections: [
                // {
                //     direction: "rhs",
                //     heading: "Venture Capital (VCC) – Fueling Innovation and High-Growth Businesses",
                //     content:
                //         "We back visionary entrepreneurs and disruptive startups with the capital and strategic guidance they need to grow. Our venture capital investments focus on scalable businesses that demonstrate strong potential for industry transformation. By investing in forward-thinking ventures, we help create the next generation of market leaders.",
                //     keyFeatures: [
                //         "Funding for startups with high-growth potential.",
                //         "Strategic mentorship and business development support.",
                //         "Access to a network of industry experts and investors",
                //     ],
                //     image: "/imges/service/Venture.jpg",
                // },
                {
                    direction: "lhs",
                    heading: "Private Equity – Long-Term Investments",
                    content:
                        "We invest in promising businesses with strong growth potential through a long-term partnership approach. Our focus is on creating sustainable value by supporting companies with capital, strategic guidance, and industry expertise.",
                    keyFeatures: [
                        "Long-term investment approach.",
                        "Strategic business partnerships.",
                        "Focus on sustainable value creation.",
                    ],
                    image: "/imges/service/PrivateEquity.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Asset Management",
                    content:
                        "Our asset management services are designed to preserve and grow capital through disciplined investment strategies. We focus on identifying opportunities that align with financial objectives and market conditions.",
                    keyFeatures: [
                        "Diversified investment strategies.",
                        "Focus on capital growth and preservation.",
                        "Professional portfolio oversight.",
                    ],
                    image: "/imges/service/assetsManagement.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Sustainable & Impact Investing",
                    content:
                        "We support investments that generate financial returns while contributing to environmental and social progress. Our approach emphasizes responsible investing practices that align with long-term development goals.",
                    keyFeatures: [
                        "Responsible investment approach.",
                        "Focus on positive social impact.",
                        "Alignment with sustainability objectives.",
                    ],
                    image: "/imges/service/sustainable.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Focus on Oman-Based Growth Opportunities",
                    content:
                        "We prioritize investment opportunities that contribute to the growth and development of Oman’s economy. By focusing on high-potential sectors, we aim to support innovation, job creation, and long-term economic value.",
                    keyFeatures: [
                        "Focus on Oman’s growth sectors.",
                        "Support for local business development.",
                        "Commitment to long-term economic progress.",
                    ],
                    image: "/imges/service/Focus.jpeg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Investments?",
            points: [
                {
                    title: "Strategic Capital<br/> Allocation",
                    description:
                        "We invest in opportunities that drive meaningful financial growth",
                    image: "/imges/service/Strategic.png",
                },
                {
                    title: "Expert-Led Decision<br/> Making",
                    description:
                        "Our team consists of seasoned investment professionals with industry expertise",
                    image: "/imges/service/Expert-Led.png",
                },
                {
                    title: "Growth-Focused  <br>Approach",
                    description:
                        "We seek businesses with strong potential and provide the resources to fuel their success.",
                    image: "/imges/service/Growth-Focused.png",
                },
                {
                    title: "Ethical and Sustainable <br>Investments",
                    description:
                        "Our focus on ESG principles reflects our commitment to responsible investing.",
                    image: "/imges/service/Ethical.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Investments",
            content:
                "Investing is more than numbers—it’s about vision, resilience, and the ability to turn opportunities into success stories. Whether you are a startup seeking capital, a business looking for strategic investment, or an investor aiming for high-value returns, Burooj Investments is your trusted partner. Let’s build the future of investment together.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/open-service-2-1.png",
        },
    },
    buroojproperties: {
        crum: "Burooj Properties",
        title: "Transforming Real Estate, Maximizing Value",
        subtitle:
            "Every property has potential—our job is to unlock it",
        description:
            "Real estate is more than just bricks and mortar—it's about creating lasting value, securing investments, and fostering thriving communities. At Burooj Properties, we bridge opportunity with expertise, ensuring investors, homeowners, and businesses experience property management that goes beyond transactions. From maximizing rental income to strategic investment advisory, we provide tailored solutions that turn real estate into a high-performing asset.",
        image: "/imges/service/buroojproperties.jpg",
        offerings: {
            title: "Our Core Services",
            sections: [
                {
                    direction: "rhs",
                    heading: "Real Estate Development & Advisory",
                    content:
                        "We provide end-to-end real estate development and advisory services, supporting projects from concept to completion. Our expertise helps clients make informed decisions across planning, design guidance, and development strategies aligned with market demand.",
                    keyFeatures: [
                        "End-to-end development support.",
                        " Strategic advisory for real estate projects.",
                        "Market-driven planning and guidance.",
                    ],
                    image: "/imges/service/RealEstate.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Property Management",
                    content:
                        "Our property management services focus on maintaining operational efficiency and value of residential and commercial assets. We handle day-to-day management activities while ensuring properties remain well-maintained and tenant-ready.",
                    keyFeatures: [
                        "Full property operational management.",
                        "Tenant coordination and support.",
                        "Maintenance and upkeep supervision.",
                    ],
                    image: "/imges/service/PropertyManagement.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Buy & Sell Facilitation – Connecting Investors, Landlords, and Buyers",
                    content:
                        "Buying or selling property requires expertise, negotiation skills, and market insight. Our team simplifies the process by offering end-to-end transaction support, from property evaluation to legal paperwork, ensuring smooth and successful deals.",
                    keyFeatures: [
                        "Market analysis to secure the best deals.",
                        "Buyer and seller matchmaking for seamless transactions.",
                        "Legal and financial assistance throughout the process.",
                    ],
                    image: "/imges/service/Buy.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Facility Management",
                    content:
                        "We offer facility management solutions that ensure buildings operate smoothly, safely, and efficiently. Our services cover maintenance, safety standards, and overall facility performance optimization.Smart real estate investments are backed by research, strategy, and market foresight. We guide investors with in-depth insights, helping them identify high-yield opportunities while minimizing risks. Whether you're entering the market or expanding your portfolio, our advisory services provide the clarity you need.",
                    keyFeatures: [
                        "Integrated facility operations support.",
                        "Preventive and corrective maintenance.",
                        "Focus on safety and efficiency.",
                    ],
                    image: "/imges/service/facilitymanagement.jpeg",
                },
                  {
                    direction: "rhs",
                    heading: "Buy & Sell Facilitation",
                    content:
                        "We assist clients in buying and selling properties by connecting them with the right opportunities and managing the transaction process. Our goal is to ensure transparent and well-informed property deals.",
                    keyFeatures: [
                        "Assistance in property transactions.",
                        "Buyer and seller matching support.",
                        "Transparent deal facilitation process.",
                    ],
                    image: "/imges/service/Buy.jpg",
                },
                {
                    direction: "lhs",
                    heading: "Investment Advisory",
                    content:
                        "Our investment advisory services guide clients in making informed real estate investment decisions. We analyze market trends and opportunities to support long-term value creation and portfolio growth.",
                    keyFeatures: [
                        "Real estate investment guidance.",
                        "Market analysis and insights.",
                        "Focus on long-term value growth",
                    ],
                    image: "/imges/service/InvestmentAdvisory.jpeg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Properties?",
            points: [
                {
                    title: "Expert Property<br/> Oversight",
                    description:
                        "Our team handles everything from tenant relations to facility maintenance.",
                    image: "/imges/service/Expert.png",
                },
                {
                    title: "Proactive Investment<br/> Approach",
                    description:
                        "We don’t just manage properties—we enhance their potential",
                    image: "/imges/service/Proactive.png",
                },
                {
                    title: "End-to-End Real Estate <br>Solutions",
                    description:
                        "Whether you need management, transactions, or investment advice, we provide a complete suite of services",
                    image: "/imges/service/End-to-End.png",
                },
                {
                    title: "Local Expertise, Global <br>Standards",
                    description:
                        "We combine regional market knowledge with international best practices",
                    image: "/imges/service/Local.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Properties",
            content:
                "Every property has a story. Whether you're an investor, landlord, or business, we help you write a profitable chapter. Reach out today to discuss how we can add value to your real estate assets.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/Partner.jpg",
        },
    },
    buroojservices: {
        crum: "Burooj Services",
        title: "Smart Solutions, Safer Operations",
        subtitle:
            "Delivering integrated technology, safety, and facility solutions for modern businesses.",
        description:
            "At Burooj Services, we help organizations create safer, smarter, and more efficient environments through advanced technology and professional support services. From security systems and automation solutions to compliance services and facility management, we provide reliable solutions that enhance operational performance while meeting industry standards and business requirements.",
        image: "/imges/service/buroojservices.jpg",
        offerings: {
            title: "Our Offerings",
            sections: [
                {
                    direction: "rhs",
                    heading: "Smart Access & Security Systems",
                    content:
                        "We design and implement advanced security solutions that help businesses protect their people, assets, and facilities. Our systems combine intelligent access control, surveillance, and monitoring technologies for enhanced security management.",
                    keyFeatures: [
                        "Advanced access control systems.",
                        "CCTV surveillance and monitoring solutions.",
                        "Integrated security management platforms.",
                    ],
                    image: "/imges/service/SmartFacility.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Safety & Automation Solutions",
                    content:
                        "We provide innovative automation and safety technologies that improve operational efficiency while maintaining secure working environments. Our solutions help businesses streamline processes and enhance day-to-day performance.",
                    keyFeatures: [
                        "Building and process automation systems.",
                        "Smart monitoring and control solutions.",
                        "Improved operational efficiency and safety.",
                    ],
                    image: "/imges/service/Safety.jpeg",
                },
                {
                    direction: "rhs",
                    heading: "Safety & Compliance Services",
                    content:
                        "We support organizations in meeting safety regulations and industry requirements through professional assessments, training, and compliance solutions. Our services help businesses maintain safe and compliant operations.",
                    keyFeatures: [
                        "Workplace safety assessments and audits.",
                        "Regulatory compliance support.",
                        "Risk management and safety training services.",
                    ],
                    image: "/imges/service/SafetyCompliance.jpeg",
                },
                {
                    direction: "lhs",
                    heading: "Smart Facility Solutions",
                    content:
                        "We deliver integrated facility solutions that optimize building performance, enhance user comfort, and support long-term operational reliability. Our approach combines technology, maintenance, and efficiency-driven services.",
                    keyFeatures: [
                        "Smart facility management solutions.",
                        "Preventive maintenance and support services.",
                        "Energy-efficient building optimization.",
                    ],
                    image: "/imges/service/SmartAccess.jpeg",
                },
            ],
        },
        whyChooseUs: {
            title: "Why Choose Burooj Services?",
            points: [
                {
                    title: "Advanced <br> Technology Expertise",
                    description:
                        "We deliver modern solutions tailored to evolving business needs.",
                    image: "/imges/service/Industry.png",
                },
                {
                    title: "Reliable<br> Safety Standards",
                    description:
                        "We help organizations maintain safe and compliant operations.",
                    image: "/imges/service/ProactiveMaintenance.png",
                },
                {
                    title: "Integrated<br> Service Approach",
                    description:
                        "Multiple solutions managed through a single trusted partner.",
                    image: "/imges/service/Regulatory.png",
                },
                {
                    title: "Operational <br>Efficiency Focus",
                    description:
                        "Improving performance while reducing operational challenges.",
                    image: "/imges/service/Technology.png",
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Services",
            content:
                "At Burooj Services, we are committed to helping businesses build safer, smarter, and more efficient environments. Whether you need advanced security systems, automation technologies, compliance support, or facility solutions, our team is ready to deliver reliable services that support your long-term success.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/Partnerservice.jpg",
        },
    }
};
export default ServiceData;